<template>
   <v-menu
      v-model="fromDateMenu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          prepend-icon="mdi-calendar"
          readonly
          :label="label"
          :value="fromDateDisp"
          v-model="initialValue"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        locale="en-in"
        :min="minDate"
        :max="maxDate"
        v-model="fromDateVal"
        no-title
        v-on:input="handleDateChange($event)"
      ></v-date-picker>
    </v-menu>
</template>

<script>
export default {
  name: 'DatePicker',
  props: {
    label: String,
    initialValue: String
  },
  data () {
    return {
      dialog: false,
      fromDateVal: this.initialValue,
      minDate: '2019-07-04',
      maxDate: '2030-08-30',
      fromDateMenu: false
    }
  },
  computed: {
    fromDateDisp () {
      return this.fromDateVal
    }
  },
  methods: {
    handleDateChange ($event) {
      this.$emit('input', $event)
      this.fromDateMenu = false
    }
  }
}
</script>

<style>
</style>
